import {
  Box,
  Button,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";

type props = {
  open: boolean;
  setOpen: Function;
  day: number;
  userId: number;
  month: number;
  year: number;
  name: string;
};

const DailyVisitReportModalLoading = () => {
  return (
    <Stack alignItems={"center"} justifyContent={"center"} spacing={2}>
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          padding: "3%",
          borderRadius: "24px",
        }}
      >
        <TableContainer sx={{ maxHeight: "60vh" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Customer Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Brick Name</TableCell>
                <TableCell>Last Update</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 4 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton width={20} height={20} />
                  </TableCell>
                  <TableCell>
                    <Skeleton width={150} height={50} />
                  </TableCell>
                  <TableCell>
                    <Skeleton width={80} height={20} />
                  </TableCell>
                  <TableCell>
                    <Skeleton width={150} height={50} />
                  </TableCell>
                  <TableCell>
                    <Skeleton width={80} height={20} />
                  </TableCell>
             
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Stack>
  );
};

export default DailyVisitReportModalLoading;
